import React from 'react'
import { useEffect } from "react";
// import "../crmComponents/Contacts.css";
import "../companyAccount/accountcontainer.css";
// import LeadView from './LeadView';
// import { useNavigate } from 'react-router-dom';
// import Accounts from './Accounts';
// import AddAccounts from './AddAccounts';
// import AddLeads from './AddLeads';
// import LeadDetail from './LeadDetail';
import AccountDetail from './AccountDetail';
import AccountListing from './AccountListing';
import { useNavigate } from 'react-router-dom';

const AccountContainer = (props) => {
  const navigate = useNavigate();
  const NextScreen = () => {
    if (props.subPageName === "account") {
      return <AccountListing authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "accountDetail") {
      return <AccountDetail authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} pageTypeHandler={props.pageTypeHandler}/>
    }
    else {
      return
    }
  }

  useEffect(() => {
    props.pageTypeHandler("Account");
  }, [])
  
  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
  },[])

  return (
    <div className='pt-[3rem]'>
      <NextScreen/>
    </div>
  )
}

export default AccountContainer
